{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified Chinese-speaking clinical research professional before activating locale=zh in production.",
  "app": {
    "name": "OneVerse",
    "loading": "加载中...",
    "save": "保存",
    "cancel": "取消",
    "delete": "删除",
    "confirm": "确认",
    "submit": "提交",
    "edit": "编辑",
    "close": "关闭",
    "back": "返回",
    "next": "下一步",
    "search": "搜索",
    "filter": "筛选",
    "export": "导出",
    "yes": "是",
    "no": "否",
    "required": "必填",
    "optional": "可选",
    "none": "无",
    "unknown": "未知",
    "error": "发生错误。请重试。",
    "powered_by": "由 {{name}} 提供支持"
  },
  "nav": {
    "home": "首页",
    "dashboard": "仪表盘",
    "submissions": "提交",
    "studies": "研究",
    "sites": "站点",
    "users": "用户",
    "settings": "设置",
    "notifications": "通知",
    "admin": "管理",
    "help": "帮助",
    "sign_out": "退出登录",
    "logout": "退出",
    "expand_sidebar": "展开侧边栏",
    "collapse_sidebar": "收起侧边栏"
  },
  "auth": {
    "sign_in": "登录",
    "sign_in_button": "登录",
    "sign_out": "退出登录",
    "email": "电子邮件",
    "email_placeholder": "请输入您的电子邮件",
    "password": "密码",
    "password_placeholder": "请输入您的密码",
    "forgot_password": "忘记密码？",
    "reset_password": "重置密码",
    "enter_reset_code": "输入重置码",
    "reset_code_instructions": "输入您的电子邮件地址，我们将发送重置密码所需的验证码。",
    "new_code_instructions": "输入验证码和新密码。",
    "send_reset_code": "发送重置码",
    "sending": "发送中...",
    "reset_password_action": "重置密码",
    "resetting": "重置中...",
    "create_account": "创建账号",
    "welcome": "欢迎使用 OneVerse",
    "remember_password": "记住您的密码？",
    "confirmation_code": "确认码",
    "confirmation_code_placeholder": "请输入您通过电子邮件或短信收到的验证码",
    "new_password": "新密码",
    "new_password_placeholder": "请输入新密码",
    "confirm_password": "确认新密码",
    "confirm_password_placeholder": "请再次输入新密码",
    "mfa": {
      "code": "验证码",
      "back_to_login": "返回登录",
      "sms_placeholder": "请输入发送至您手机的验证码",
      "email_placeholder": "请输入发送至您邮箱的验证码",
      "totp_placeholder": "请输入认证应用中的验证码"
    },
    "show_password": "显示密码",
    "hide_password": "隐藏密码",
    "errors": {
      "invalid_credentials": "电子邮件或密码无效。",
      "account_locked": "您的账号已被锁定。请联系支持人员。",
      "session_expired": "您的会话已过期。请重新登录。",
      "email_required": "电子邮件为必填项",
      "email_password_required": "电子邮件和密码为必填项",
      "all_fields_required": "所有字段均为必填项",
      "passwords_dont_match": "密码不匹配",
      "unexpected": "发生意外错误",
      "server_non_json": "服务器返回了非 JSON 响应。请查看控制台。"
    },
    "welcome_back": "欢迎回来",
    "subtitle": "请输入您的详细信息。",
    "no_account": "没有账户？",
    "sign_up": "注册"
  },
  "dashboard": {
    "welcome": "欢迎，{{name}}",
    "new_submission": "新建提交",
    "submission_overview": "提交概览",
    "view_all_submissions": "查看所有提交",
    "recent_activity": "最近活动",
    "no_recent_activities": "暂无最近活动。",
    "search_placeholder": "搜索",
    "total": "总计",
    "submission_singular": "份提交",
    "submission_plural": "份提交",
    "active_site_status": "活跃站点状态",
    "view_study": "查看研究",
    "loading_studies": "加载研究中...",
    "select_study": "选择研究",
    "view_details": "查看详情",
    "news_and_notes": "新闻与备注",
    "no_recent_posts": "暂无最近发布。",
    "failed_to_load_announcements": "加载公告失败",
    "statuses": {
      "response_required": "需要回应",
      "drafts": "草稿",
      "submitted": "已提交",
      "pre_review": "预审",
      "irb_review": "IRB审查",
      "post_review": "审后处理",
      "expiring_soon": "即将过期"
    }
  },
  "submissions": {
    "title": "提交列表",
    "new": "新建提交",
    "empty": "未找到提交。",
    "status": {
      "pending": "待处理",
      "under_review": "审核中",
      "approved": "已批准",
      "rejected": "已拒绝",
      "revisions_required": "需要修改",
      "withdrawn": "已撤回",
      "expired": "已过期",
      "closed": "已关闭",
      "draft": "草稿",
      "submitted": "已提交",
      "pre_review": "预审",
      "irb_review": "IRB审查",
      "post_review": "审后处理",
      "response_required": "需要回应",
      "expiring_soon": "即将过期",
      "complete": "完成",
      "deleted": "已删除"
    },
    "fields": {
      "title": "标题",
      "protocol_number": "方案编号",
      "principal_investigator": "主要研究者",
      "submitted_at": "提交时间",
      "updated_at": "最后更新",
      "status": "状态",
      "type": "类型",
      "id": "ID",
      "submitted": "提交日期",
      "expiration": "到期日"
    },
    "actions": {
      "view": "查看提交",
      "edit": "编辑提交",
      "withdraw": "撤回",
      "submit": "提交审查"
    },
    "empty_yet": "暂无申请。",
    "search_placeholder": "按ID或标题搜索",
    "filter": {
      "all_statuses": "所有状态",
      "all_types": "所有类型",
      "status_label": "状态",
      "type_label": "类型"
    },
    "errors": {
      "failed_to_load": "加载申请失败"
    }
  },
  "studies": {
    "title": "研究列表",
    "new": "新建研究",
    "empty": "未找到研究。",
    "fields": {
      "title": "研究标题",
      "irb_number": "IRB编号",
      "pi": "主要研究者",
      "status": "状态",
      "start_date": "开始日期",
      "end_date": "结束日期",
      "id": "ID",
      "type": "类型",
      "submitted": "提交日期",
      "expiration": "到期日"
    },
    "empty_yet": "暂无研究。",
    "search_placeholder": "按ID或标题搜索",
    "filter": {
      "all_statuses": "所有状态",
      "all_types": "所有类型",
      "type_label": "类型",
      "attribute_label": "属性",
      "all_attributes": "所有属性",
      "attribute_value_placeholder": "属性值"
    },
    "errors": {
      "failed_to_load": "加载研究失败"
    },
    "standalone": "独立",
    "sort_by": "按{{column}}排序",
    "attributes": {
      "cro": "CRO",
      "sponsor": "申办方",
      "pi": "PI",
      "pi_email": "PI邮箱",
      "poc": "POC",
      "poc_email": "POC邮箱",
      "poc_phone": "POC电话",
      "poc_role": "POC角色"
    }
  },
  "sites": {
    "title": "站点列表",
    "new": "新建站点",
    "empty": "未找到站点。",
    "empty_yet": "暂无机构。",
    "search_placeholder": "按ID、机构名称或PI搜索",
    "filter": {
      "all_statuses": "所有状态",
      "all_countries": "所有国家",
      "country_label": "国家"
    },
    "errors": {
      "failed_to_load": "加载机构失败"
    },
    "fields": {
      "id": "ID",
      "site_name": "机构名称",
      "country": "国家",
      "protocol_number": "方案编号",
      "sponsor_name": "申办方名称",
      "pi_name": "PI姓名",
      "approved": "已批准",
      "expiration": "到期日",
      "status": "状态"
    }
  },
  "errors": {
    "not_found": "未找到请求的资源。",
    "unauthorized": "您无权执行此操作。",
    "server_error": "发生服务器错误。请稍后重试。",
    "network_error": "发生网络错误。请检查您的连接。",
    "not_found_title": "我们找不到此页面",
    "not_found_body": "您访问的页面不存在或已被移动。",
    "go_back": "返回"
  },
  "pagination": {
    "previous": "上一页",
    "next": "下一页",
    "page": "第 {{current}} 页，共 {{total}} 页",
    "showing": "显示 {{from}}–{{to}}，共 {{total}} 条"
  },
  "dates": {
    "today": "今天",
    "yesterday": "昨天",
    "just_now": "刚刚",
    "ago": "{{time}}前"
  },
  "entity": {
    "status": {
      "in_progress": "进行中",
      "active": "活跃",
      "rejected": "已拒绝",
      "suspended": "已暂停",
      "closed": "已关闭",
      "expired": "已过期"
    }
  },
  "activities": {
    "submission_approved": "申请已批准",
    "submission_created": "已创建申请",
    "submission_submitted": "已提交申请",
    "submission_updated": "已更新申请",
    "submission_withdrawn": "申请已撤回",
    "submission_rejected": "申请已拒绝",
    "submission_expired": "申请已过期",
    "study_created": "已创建研究",
    "study_updated": "已更新研究",
    "site_created": "已创建机构",
    "site_updated": "已更新机构",
    "status_changed": "状态已更改",
    "review_started": "审查开始",
    "review_completed": "审查完成",
    "comment_added": "已添加评论",
    "document_uploaded": "已上传文件",
    "response_required": "需要回复"
  }
}
